import { get } from 'lodash';
import { HourStatus } from '@scentregroup/shared/graphql/__generated__/graphql-codegen';
import { HOURS_BANNER_DINELATE, STORE_HOURS_DIFFER } from '../../constants';
export function getNonBannerDescription(storeDescription, parsedCentreHour, defaultDescription, useCentrePrefix) {
  const centreDescriptionMaybeDineTillLate = parsedCentreHour ? parsedCentreHour.text.description : '';
  // This is a hack to deal with already parsed data instead of an
  // intermediate form. To be remove when refactoring.
  const centreDescription = centreDescriptionMaybeDineTillLate === HOURS_BANNER_DINELATE ? '' : centreDescriptionMaybeDineTillLate;
  const prefix = useCentrePrefix && parsedCentreHour ? {
    [HourStatus.Closed]: 'Centre closed',
    [HourStatus.Overnight]: 'Centre open late',
    [HourStatus.Multiple]: 'Centre hours differ',
    [HourStatus.Normal]: ''
  }[parsedCentreHour.status] : '';
  const infix = get(storeDescription, 'description') || centreDescription;
  const withoutSuffix = "".concat(prefix).concat(prefix && infix ? ': ' : '').concat(infix);
  const newDescription = withoutSuffix ? "".concat(withoutSuffix, " ").concat(STORE_HOURS_DIFFER) : '';
  return {
    isColored: Boolean(newDescription),
    description: newDescription || defaultDescription
  };
}